import { useSyncExternalStore } from "react";
import i18next from "i18next";

const subscribe = (onChange: () => void) => {
	i18next.on("languageChanged", onChange);
	return () => { i18next.off("languageChanged", onChange); };
};
const snapshot = () => i18next.resolvedLanguage || i18next.language || "en";

/** Re-render labels without remounting the form or losing unsaved input. */
export function useLocale() {
	return useSyncExternalStore(subscribe, snapshot, snapshot);
}
